import { PhoneCall } from "lucide-react";
import { useLanguage } from "../../context/LanguageContext";
import { useNavigate } from "react-router-dom";

export function SellerCtaSection({ ctaData }) {
  const { translate } = useLanguage();
  const navigate = useNavigate();

  const title =
    ctaData?.title?.value ||
    translate("newSeller.cta.heading") ||
    "Ready to get the best price for your car?";
  const subtitle =
    ctaData?.subtitle?.value || translate("newSeller.cta.subtitle") || "";
  const primaryText =
    ctaData?.primary_btn_text?.value ||
    translate("newSeller.cta.startSelling") ||
    "Start Selling Today";
  const primaryLink = ctaData?.primary_btn_link?.value || "/register";
  const secondaryText =
    ctaData?.secondary_btn_text?.value ||
    translate("newSeller.cta.contactSupport") ||
    "Contact Seller Support";
  const secondaryLink = ctaData?.secondary_btn_link?.value || "/contact";

  return (
    <section className="relative bg-primary py-20 sm:py-24 lg:py-32 overflow-hidden">
      <div
        className="absolute inset-0 opacity-10 pointer-events-none"
        style={{
          backgroundImage:
            "linear-gradient(45deg, transparent 50%, rgba(255,255,255,0.2) 50%)",
          backgroundSize: "100% 100%",
        }}
      />

      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10 text-center">
        <h2 className="text-3xl sm:text-4xl font-black text-white mb-8 tracking-tighter leading-tight">
          {title}
        </h2>

        <p className="text-blue-100 text-lg mb-12 max-w-2xl mx-auto font-medium leading-relaxed">
          <span dangerouslySetInnerHTML={{ __html: subtitle }} />
        </p>

        <div className="flex flex-col sm:flex-row gap-6 justify-center items-center">
          <button
            className="w-full sm:w-auto bg-white hover:bg-gray-100 text-[#1d63a3] px-10 py-5 rounded-2xl font-black text-lg transition-all shadow-xl shadow-black/10"
            onClick={() => primaryLink && (window.location.href = primaryLink)}
          >
            {primaryText}
          </button>

          <button
            onClick={() => navigate(secondaryLink)}
            className="w-full sm:w-auto flex items-center justify-center gap-3 text-white hover:text-blue-100 font-bold text-lg transition-colors group"
          >
            <span className="font-bold">{secondaryText}</span>
            <PhoneCall className="w-5 h-5 transition-transform group-hover:scale-110" />
          </button>
        </div>
      </div>
    </section>
  );
}
